export const operationTypeAdapter = (operationType) => {
  return {
    id: operationType.id,
    name: operationType.name,
  };
};
